export default __webpack_public_path__ + "static/media/Banner-Productos-Tekbond.7c0cda21.jpg";